export default class ReminderGroup {
  constructor({
    id = 0,
    number = null,
    name = null,
    inclusionStatus = false,
    isWholesaler = false,
    payTerm = null,
    customerNumber = null,
    deleteAction = false,
    notice = {
      courtesy: false,
      reminder1: false,
      reminder2: false,
      reminder3: false,
      restrictNotice: false
    }
  } = {}) {
    this.id = id;
    this.number = number;
    this.name = name;
    this.inclusionStatus = inclusionStatus;
    this.isWholesaler = isWholesaler;
    this.payTerm = payTerm;
    this.customerNumber = customerNumber;
    this.deleteAction = deleteAction;
    this.notice = notice;
  }
}